export default "__VITE_ASSET__CRim9kT9__"